import { translate } from 'react-i18next';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose, hoistStatics, withState, lifecycle, withHandlers, withPropsOnChange, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import Ticket from './Ticket';
import WithLoading from '../../../../components/WithLoading';
import TicketService from '../../../../services/ticket.service';

const mapStateToProps = state => ({
  currentUser: state.user.user.id,
});

const markAsResolved = props => async (e) => {
  e.preventDefault();
  const {
    t,
    setCurrentTicket,
    currentTicket,
    setUpdated,
    setFormData,
    setIsSubmittingStatus,
    isSubmittingStatus } = props;
  if (!isSubmittingStatus) {
    setIsSubmittingStatus(true);
    if (currentTicket.status !== TicketService.STATUS_RESOLVED) {
      const resp = await TicketService.updateAttribute(
        currentTicket.id, 'status',
        TicketService.STATUS_RESOLVED,
      );
      if (resp.model) {
        setCurrentTicket(resp.model);
        const status = TicketService.getStatusList(t)[resp.model.status];
        const created_at = moment(resp.model.created_at).format('ll');
        const last_replay_at = moment(resp.model.last_replay_at).format('ll');
        setFormData({ ...currentTicket, ...resp.model, status, created_at, last_replay_at });
        setUpdated({ id: currentTicket.id });
      }
    }
    setIsSubmittingStatus(false);
  }
};


const prepareData = async (props) => {
  const { setFormData, setCurrentTicket, t, history } = props;
  const currentTicket = await TicketService.get(props.match.params.id);
  if (!currentTicket.errors) {
    const status = TicketService.getStatusList(t)[currentTicket.status];
    const created_at = moment(currentTicket.created_at).format('ll');
    const last_replay_at = moment(currentTicket.last_replay_at).format('ll');
    setFormData({ ...currentTicket, status, created_at, last_replay_at });
    setCurrentTicket(currentTicket);
  } else {
    setFormData(null);
    history.push('/ticket');
  }
};

const enhance = compose(
  connect(mapStateToProps, null),
  withState('isLoading', 'setIsLoading', true),
  withState('isSubmittingStatus', 'setIsSubmittingStatus', false),
  withState('formData', 'setFormData', null),
  withState('currentTicket', 'setCurrentTicket', null),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      this.props.setIsLoading(false);
      await prepareData(this.props);
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.id !== this.props.match.params.id) {
        await prepareData(nextProps);
      }
    },
  }),
  withHandlers({
    markAsResolved,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Ticket)));



// WEBPACK FOOTER //
// ./src/views/modules/ticket/ticket/index.js